import React, { useState, useEffect } from "react";
import HeaderOne from '../../Header/HeaderOne';
import FooterOne from '../../Footer/FooterOne';
import BannerOne from '../../HomeOne/BannerOne/BannerOne';
import Service from '../../HomeOne/Service/Service';
import AboutOne from '../../HomeOne/AboutOne/AboutOne';
// import Choose from '../../HomeOne/Choose/Choose';
import Team from '../../HomeOne/Team/Team';
// import Testimonial from '../../HomeOne/Testimonial/Testimonial';
// import Brand from '../../HomeOne/Brand/Brand';
// import Blog from '../../HomeOne/Blog/Blog';
import { pageTitle } from '../../PageTitle';
// import { launchFireworks } from "../../../Pages/Courses/firework";
//import ParticleNetwork from "../../Courses/ParticleNetwork";



const HomeOne = () => {
    pageTitle('Smart iLab Works');
    // launchFireworks();
      const [showParticles, setShowParticles] = useState(true);
    
      useEffect(() => {
        const timer = setTimeout(() => {
          setShowParticles(false);
        }, 50000); // 5 seconds
    
        return () => clearTimeout(timer);
      }, []);
    return (
        <>
            { /* showParticles && <ParticleNetwork /> */}
            <HeaderOne></HeaderOne>
            <BannerOne></BannerOne>
            <Service></Service>
            <AboutOne></AboutOne>
            {/* <Choose></Choose> */}
            <Team></Team>
            {/* <Testimonial></Testimonial> */}
            {/* <Brand></Brand> */}
            {/* <Blog></Blog> */}
            <FooterOne></FooterOne>
        </>
    );
};

export default HomeOne;